// ---Third-party imports
import React from 'react';
import { useState, useDelay } from 'uix/hooks';
export const DelayedDisplay = ({ children, delay = 1000 })=>{
    let [visible, setVisible] = useState(false);
    useDelay(()=>setVisible(true), [
        delay
    ]);
    if (visible) {
        return children;
    } else {
        return null;
    }
};
